import React, { PropTypes } from "react";

import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { change as changeFieldValue, Field, formValueSelector, reduxForm, } from "redux-form";

import {
  CheckboxInput,
  DayPicker,
  NewSelectInput,
} from "../../../../../../common/form/index.js";

import { bindActionCreators } from "redux";
import validationUtils from "../../../../../../../utils/ValidationUtils.js";
import Render from "../../../../../../common/Render.js";
import employmentTypes from "../../enums/employmentTypes.js";
import { EMPLOYMENT_VALIDATION_RULES } from "./employmentsValidationRules.js";

const formName = "employment";
class BasicEmploymentFields extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.defineEndDate = this.defineEndDate.bind(this);
  }
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }
  defineEndDate(event) {
    const checked = event.target.checked;

    if (!checked) {
      this.props.changeFieldValue(formName, "endDate", null);
    }
  }

  render() {
    const { disabled, handleSubmit, defineEndDate } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <fieldset disabled={disabled}>
          <Field
            id="startDate"
            name="startDate"
            component={DayPicker}
            type="text"
            required={true}
            label={<FormattedMessage id="employments.form.startDate" />}
            disabled={disabled}
          />
          <Render
            if={!disabled}
          >
            <Field
              props={{ onChange: this.defineEndDate }}
              id="defineEndDate"
              name="defineEndDate"
              component={CheckboxInput}
              checkbox={{ value: true }}
              label={
                <FormattedMessage id="employments.form.defineEndDate" />
              }
              disabled={disabled}
              normalize={(value) => !!value}
            />
          </Render>
          <Render
            if={
              defineEndDate
            }
          >
            <Field
              id="endDate"
              name="endDate"
              component={DayPicker}
              type="text"
              label={<FormattedMessage id="employments.form.endDate" />}
              disabled={disabled}
            />
          </Render>
          <Field
            id="employmentType"
            name="employmentType"
            component={NewSelectInput}
            label={<FormattedMessage id="employments.form.employmentType" />}
            options={employmentTypes}
            searchable={true}
            required={true}
            disabled={disabled}
          />
        </fieldset>
      </form>
    );
  }
}

BasicEmploymentFields.propTypes = {
  disabled: PropTypes.bool,
  handleSubmit: PropTypes.func,
  changeFieldValue: PropTypes.func,
  scene: PropTypes.string,
  defineEndDate: PropTypes.bool,
};

BasicEmploymentFields.defaultProps = {
  disabled: false,
  scene: "",
};

BasicEmploymentFields.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state) {
  const selector = formValueSelector(formName);

  return {
    defineEndDate: selector(state, "defineEndDate"),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(
  reduxForm({
    form: formName,
    validate: (values) =>
      validationUtils.validate(values, EMPLOYMENT_VALIDATION_RULES),
  })(BasicEmploymentFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/employments/BasicEmploymentFields.js